import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import InfiniteScroll from "react-infinite-scroll-component";
import FieldAgentOrderCard from "./FieldAgentOrderCard";
import EmptyError from "../EmptyError/EmptyError";
import CustomDateRange from "../Hisaab/CustomDateRange";
import { useEffect } from "react";
import AnalyticsService from "../../Services/AnalyticsService";
import PartnersSearch from "../Partners/PartnersSearch";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  selectedFilter: {
    backgroundColor: "#9D2123 !important",
    color: "#FFFFFF",
    fontWeight: 700,
  },
  unselectedFilter: {
    backgroundColor: "#FFFFFF !important",
    color: "#4F4F4F",
    fontWeight: 700,
  },
}));

const FieldAgentOrders = ({
  loading,
  setLoading,
  ordersList,
  currentCount,
  totalCount,
  getAgentOrders,
  orderDateRangeFilter,
  setOrderDateRangeFilter,
  handleClearOrderDateRangeFilter,
  handleSearch,
  clearSearch,
  searchKeyword,
  currentTab,
  error,
  ORDER_TYPE_FILTERS,
  setFilterValueToDefault,
  isFilterSelected,
}) => {
  const classes = useStyles();
  useEffect(() => {
    AnalyticsService.pushEvent(`Page Viewed`, { page: "Agent Orders" });
  }, []);

  const handleClearAllFilters = () => {
    AnalyticsService.pushEvent(`Button Clicked`, {
      type: "Clear All Filters",
      page: "Partner Orders",
    });
    sessionStorage.removeItem("partnerOrderTabClicked", true);
    setFilterValueToDefault("MY_ORDERS");
    setFilterValueToDefault("CST_ORDERS");
    setFilterValueToDefault("FIELD_ORDERS");
    setFilterValueToDefault("PARTNER_SELF_CHECKOUT_ORDERS");
    clearSearch();
    handleClearOrderDateRangeFilter();
  };

  const handleFilterClick = (selectedStatusFilter) => {
    sessionStorage.removeItem("partnerOrderTabClicked", true);
    let selectedOrderStatusFilter = _.find(ORDER_TYPE_FILTERS, {
      identifier: selectedStatusFilter.identifier,
    });
    selectedOrderStatusFilter.selected = !selectedOrderStatusFilter.selected;
    AnalyticsService.pushEvent(`Filter Clicked`, {
      page: window.location.pathname || "",
      filterLabel: selectedStatusFilter?.label || "",
      filterStatus: selectedStatusFilter?.selected ? "Applied" : "Removed",
      identifier: selectedStatusFilter.identifier,
    });
    setLoading("started");
    getAgentOrders({
      fetchFromStarting: true,
      myOrders: isFilterSelected("MY_ORDERS"),
      cstOrders: isFilterSelected("CST_ORDERS"),
      fieldOrders: isFilterSelected("FIELD_ORDERS"),
      partnerSelfCheckOutOrders: isFilterSelected(
        "PARTNER_SELF_CHECKOUT_ORDERS"
      ),
    });
  };

  return (
    <BlockUi
      tag="div"
      blocking={loading === "started"}
      message={`Loading...`}
      style={{ minHeight: "85vh" }}
      keepInView
    >
      <Container maxWidth={`xl`} sx={{ pb: 1 }}>
        <PartnersSearch
          handleSearch={handleSearch}
          clearSearch={clearSearch}
          searchKeyword={searchKeyword}
          page={"Agent Orders"}
        />
      </Container>
      <Container maxWidth={`xl`} sx={{ padding: 0 }}>
        <Box
          sx={{
            padding: "0px 16px",
            marginBottom: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{
              margin: "4px 0px",
              overflowX: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <CustomDateRange
              filterLabel="Filter By Date"
              maxDate={new Date()}
              selectedDateRangeFilter={orderDateRangeFilter}
              setSelectedDateRangeFilter={setOrderDateRangeFilter}
              page={"My Orders"}
            />
            {_.map(ORDER_TYPE_FILTERS, (filter, index) => {
              return (
                <Box
                  key={index}
                  sx={{
                    boxShadow: "0px 0px 6px rgba(28, 28, 28, 0.1);",
                    borderRadius: "16px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    display: "flex",
                    alignItems: "center",
                    maxHeight: "32px",
                  }}
                  // onClick={handleFilterClick(filter)}
                  onClick={() => {
                    handleFilterClick(filter);
                  }}
                  className={
                    filter?.selected === true
                      ? `${classes.selectedFilter}`
                      : `${classes.unselectedFilter}`
                  }
                >
                  <Typography
                    noWrap
                    sx={{
                      fontSize: "12px",
                      fontWeight: 700,
                    }}
                  >
                    {filter?.label}
                  </Typography>
                  {filter.selected === true ? (
                    <CloseIcon sx={{ fontSize: "18px", marginLeft: "4px" }} />
                  ) : (
                    <></>
                  )}
                </Box>
              );
            })}
          </Stack>
        </Box>
        <Grid
          container
          direction={"row"}
          sx={{ marginTop: "8px", padding: "0px 19px" }}
        >
          <Grid item xs={9}>
            <Typography
              variant={`body2`}
              sx={{
                color: "#33333380",
                fontWeight: "700",
                fontSize: "12px",
              }}
            >
              {totalCount} Total Orders
            </Typography>
          </Grid>
          <Grid item xs={3} sx={{ textAlign: "end", marginRight: "-10px" }}>
            <Typography
              sx={{
                color: "#33333380",
                fontWeight: "700",
                fontSize: "12px",
              }}
              onClick={handleClearAllFilters}
            >
              Clear All
            </Typography>
          </Grid>
        </Grid>
        {ordersList?.length ? (
          <InfiniteScroll
            dataLength={currentCount}
            next={() =>
              getAgentOrders({
                fetchFromStarting: false,
                myOrders: isFilterSelected("MY_ORDERS"),
                cstOrders: isFilterSelected("CST_ORDERS"),
                fieldOrders: isFilterSelected("FIELD_ORDERS"),
                partnerSelfCheckOutOrders: isFilterSelected(
                  "PARTNER_SELF_CHECKOUT_ORDERS"
                ),
              })
            }
            hasMore={currentCount < totalCount}
            loader={<p style={{ textAlign: "center" }}>Loading...</p>}
            style={{ padding: "10px 16px 125px 16px" }}
          >
            {ordersList?.map((order) => (
              <FieldAgentOrderCard
                key={order?.orderId}
                order={order}
                currentTab={currentTab}
              />
            ))}
          </InfiniteScroll>
        ) : (
          loading === "done" && (
            <EmptyError text="No Orders Found" hideBack={true} />
          )
        )}
        {loading == "done" && error && (
          <EmptyError
            text="Something went wrong. Please try again later."
            hideBack={true}
          />
        )}
      </Container>
    </BlockUi>
  );
};

export default FieldAgentOrders;
